export default __webpack_public_path__ + "static/media/ic_clock.c5274213.svg";